

export function createNotificationDropdown() {
  const notificationBtn = document.getElementById('notificationBtn');
  if (!notificationBtn) return;

  // 이미 열려있는 알림창이 있는지 확인
  const existingDropdown = document.getElementById('notificationDropdown');

  if (existingDropdown) {
    // 알림창이 열려있으면 닫기
    existingDropdown.classList.remove('dropdown--open');
    notificationBtn.classList.remove('header__icon-button--active');

    // 애니메이션 후 DOM에서 제거
    setTimeout(() => {
      if (existingDropdown.parentElement) {
        existingDropdown.parentElement.removeChild(existingDropdown);
      }
    }, 300); // CSS transition 시간에 맞춰 조정
    return;
  }

  // 알림창이 없으면 새로 생성
  const dropdown = document.createElement('div');
  dropdown.id = 'notificationDropdown';
  dropdown.className = 'dropdown dropdown--notifications';
  dropdown.innerHTML = `
    <div class="dropdown__header">
      <h3>알림</h3>
      <button class="btn btn--sm btn--outline">모두 읽음</button>
    </div>
    <div class="dropdown__body">
      <div class="notification-item">
        Phase 2에서 구현 예정입니다
      </div>
    </div>
  `;

  notificationBtn.parentElement.style.position = 'relative';
  notificationBtn.parentElement.appendChild(dropdown);

  setTimeout(() => {
    notificationBtn.classList.add('header__icon-button--active');
    dropdown.classList.add('dropdown--open');
  }, 10);
}

// 선택된 강의 정보를 관리하는 유틸리티 함수들
export function getSelectedClassId() {
  return sessionStorage.getItem('selected_class_id') || null;
}

export function getSelectedClassTitle() {
  return sessionStorage.getItem('selected_class_title') || null;
}

export function setSelectedClass(classId, classTitle) {
  if (classId) {
    sessionStorage.setItem('selected_class_id', classId);
    if (classTitle) {
      sessionStorage.setItem('selected_class_title', classTitle);
    }
  } else {
    sessionStorage.removeItem('selected_class_id');
    sessionStorage.removeItem('selected_class_title');
  }
}

export function clearSelectedClass() {
  sessionStorage.removeItem('selected_class_id');
  sessionStorage.removeItem('selected_class_title');
}

export function hasSelectedClass() {
  return !!sessionStorage.getItem('selected_class_id');
}

// 사용자 유형 관리 (개인사용자 / 기관 소속)
export function getUserType() {
  return sessionStorage.getItem('user_type') || null;
}

export function isIndividualUser() {
  return sessionStorage.getItem('user_type') === 'individual';
}

export function setUserType(type) {
  sessionStorage.setItem('user_type', type);
}

// BASIC_CLASS 판별
export function isBasicClass(classId) {
  return String(classId) === String(process.env.REACT_APP_BASIC_CLASS_ID);
}

// 클래스 타입별 테마 적용 (일반 클래스: 올리브, 개인 플랜: 짙은 갈색)
export function applyPlanTheme(classId) {
  if (isBasicClass(classId)) {
    document.documentElement.setAttribute('data-plan', 'basic');
  } else if (classId) {
    document.documentElement.setAttribute('data-plan', 'class');
  } else {
    document.documentElement.removeAttribute('data-plan');
  }
}

// 확인 모달 함수 (Promise 기반) — Figma 2047:12923
export function showConfirm(message, options = {}) {
  return new Promise((resolve) => {
    // 이미 열려있는 모달이 있으면 제거
    const existingOverlay = document.getElementById('confirm-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }

    const {
      title = '확인',
      confirmText = '확인',
      cancelText = '취소',
      icon = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="7" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
      confirmIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
      confirmButtonClass = 'btn-confirm--primary',
      cancelButtonClass = 'btn-confirm--secondary'
    } = options;

    // CSS 스타일 추가 (한 번만)
    if (!document.getElementById('confirm-modal-styles')) {
      const style = document.createElement('style');
      style.id = 'confirm-modal-styles';
      style.textContent = `
        .confirm-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.55);
          backdrop-filter: blur(4px);
          z-index: 10000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: confirmFadeIn 0.2s ease-out;
        }
        @keyframes confirmFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .confirm-modal {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);
          padding: 20px;
          width: 100%;
          max-width: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          overflow: hidden;
          font-family: var(--font-sans, -apple-system, BlinkMacSystemFont, "Pretendard", "Segoe UI", sans-serif);
          animation: confirmSlideUp 0.22s ease-out;
        }
        @keyframes confirmSlideUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .confirm-modal__icon {
          width: 40px;
          height: 40px;
          display: grid;
          place-items: center;
          color: var(--fg-anti-red, #ff1500);
        }
        .confirm-modal__icon > svg { display: block; }
        .confirm-modal__title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          line-height: 28px;
          color: var(--fg-text-basic, #3b3b3b);
          text-align: center;
          word-break: keep-all;
        }
        .confirm-modal__message {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          color: var(--fg-text-basic, #3b3b3b);
          text-align: center;
          white-space: pre-line;
          word-break: keep-all;
        }
        .confirm-modal__actions {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding-top: 12px;
          width: 100%;
        }
        .btn-confirm {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          min-height: 42px;
          padding: 6px 12px;
          border: 0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 16px;
          font-weight: 700;
          line-height: 1;
          color: #ffffff;
          cursor: pointer;
          transition: background 120ms ease, transform 120ms ease;
        }
        .btn-confirm svg { display: block; }
        .btn-confirm--primary {
          background: var(--fg-button, #978cca);
        }
        .btn-confirm--primary:hover:not(:disabled) {
          background: var(--fg-button-hover, #7362c2);
        }
        .btn-confirm--secondary {
          background: var(--fg-text-gray, #838383);
        }
        .btn-confirm--secondary:hover:not(:disabled) {
          background: #6f6f6f;
        }
        .btn-confirm--danger {
          background: var(--fg-anti-red, #ff1500);
        }
        .btn-confirm--danger:hover:not(:disabled) {
          background: #d11200;
        }
        .btn-confirm:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }
      `;
      document.head.appendChild(style);
    }

    // 오버레이 생성
    const overlay = document.createElement('div');
    overlay.id = 'confirm-overlay';
    overlay.className = 'confirm-overlay';

    // 모달 생성
    const modal = document.createElement('div');
    modal.className = 'confirm-modal';

    const iconDiv = document.createElement('div');
    iconDiv.className = 'confirm-modal__icon';
    iconDiv.innerHTML = icon;

    const titleEl = document.createElement('h2');
    titleEl.className = 'confirm-modal__title';
    titleEl.textContent = title;

    const messageEl = document.createElement('p');
    messageEl.className = 'confirm-modal__message';
    messageEl.textContent = message;

    const actions = document.createElement('div');
    actions.className = 'confirm-modal__actions';

    // 확인 버튼 (체크 아이콘 + 텍스트, Figma 좌측 배치)
    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = `btn-confirm ${confirmButtonClass}`;
    confirmBtn.dataset.action = 'confirm';
    if (confirmIcon) {
      const iconHost = document.createElement('span');
      iconHost.className = 'btn-confirm__icon';
      iconHost.innerHTML = confirmIcon;
      confirmBtn.appendChild(iconHost);
    }
    const confirmLabel = document.createElement('span');
    confirmLabel.textContent = confirmText;
    confirmBtn.appendChild(confirmLabel);

    // 취소 버튼
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = `btn-confirm ${cancelButtonClass}`;
    cancelBtn.dataset.action = 'cancel';
    cancelBtn.textContent = cancelText;

    actions.appendChild(confirmBtn);
    actions.appendChild(cancelBtn);

    modal.appendChild(iconDiv);
    modal.appendChild(titleEl);
    modal.appendChild(messageEl);
    modal.appendChild(actions);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // 모달 클릭 시 닫히지 않도록
    modal.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // 오버레이 클릭 시 취소
    overlay.addEventListener('click', () => {
      removeModal();
      resolve(false);
    });

    // 버튼 이벤트
    const handleAction = (action) => {
      removeModal();
      resolve(action === 'confirm');
    };

    modal.querySelectorAll('[data-action]').forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        handleAction(button.dataset.action);
      });
    });

    // ESC 키로 닫기
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        removeModal();
        resolve(false);
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);

    // 모달 제거 함수
    function removeModal() {
      overlay.style.animation = 'confirmFadeIn 0.2s ease-out reverse';
      modal.style.animation = 'confirmSlideUp 0.22s ease-out reverse';
      setTimeout(() => {
        if (overlay.parentElement) {
          overlay.parentElement.removeChild(overlay);
        }
        document.removeEventListener('keydown', handleEscape);
      }, 220);
    }
  });
}

// 3-way 확인 모달 (예 / 아니오 / 취소) — Figma 2047:12923 스타일 공유
export function showTripleConfirm(message, options = {}) {
  return new Promise((resolve) => {
    const existingOverlay = document.getElementById('confirm-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }

    const {
      title = '확인',
      confirmText = '예',
      neutralText = '아니오',
      cancelText = '취소',
      icon = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="7" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
      confirmIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
      confirmButtonClass = 'btn-confirm--primary',
      neutralButtonClass = 'btn-confirm--secondary',
      cancelButtonClass = 'btn-confirm--secondary'
    } = options;

    // CSS 스타일 주입 (showConfirm과 동일 — id 기반으로 한 번만 적용)
    if (!document.getElementById('confirm-modal-styles')) {
      const style = document.createElement('style');
      style.id = 'confirm-modal-styles';
      style.textContent = `
        .confirm-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.55);
          backdrop-filter: blur(4px);
          z-index: 10000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: confirmFadeIn 0.2s ease-out;
        }
        @keyframes confirmFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .confirm-modal {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);
          padding: 20px;
          width: 100%;
          max-width: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          overflow: hidden;
          font-family: var(--font-sans, -apple-system, BlinkMacSystemFont, "Pretendard", "Segoe UI", sans-serif);
          animation: confirmSlideUp 0.22s ease-out;
        }
        @keyframes confirmSlideUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .confirm-modal__icon {
          width: 40px;
          height: 40px;
          display: grid;
          place-items: center;
          color: var(--fg-anti-red, #ff1500);
        }
        .confirm-modal__icon > svg { display: block; }
        .confirm-modal__title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          line-height: 28px;
          color: var(--fg-text-basic, #3b3b3b);
          text-align: center;
          word-break: keep-all;
        }
        .confirm-modal__message {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          color: var(--fg-text-basic, #3b3b3b);
          text-align: center;
          white-space: pre-line;
          word-break: keep-all;
        }
        .confirm-modal__actions {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding-top: 12px;
          width: 100%;
          flex-wrap: wrap;
        }
        .btn-confirm {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          min-height: 42px;
          padding: 6px 12px;
          border: 0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 16px;
          font-weight: 700;
          line-height: 1;
          color: #ffffff;
          cursor: pointer;
          transition: background 120ms ease, transform 120ms ease;
        }
        .btn-confirm svg { display: block; }
        .btn-confirm--primary {
          background: var(--fg-button, #978cca);
        }
        .btn-confirm--primary:hover:not(:disabled) {
          background: var(--fg-button-hover, #7362c2);
        }
        .btn-confirm--secondary {
          background: var(--fg-text-gray, #838383);
        }
        .btn-confirm--secondary:hover:not(:disabled) {
          background: #6f6f6f;
        }
        .btn-confirm--danger {
          background: var(--fg-anti-red, #ff1500);
        }
        .btn-confirm--danger:hover:not(:disabled) {
          background: #d11200;
        }
        .btn-confirm:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }
      `;
      document.head.appendChild(style);
    }

    const overlay = document.createElement('div');
    overlay.id = 'confirm-overlay';
    overlay.className = 'confirm-overlay';

    const modal = document.createElement('div');
    modal.className = 'confirm-modal';

    const iconDiv = document.createElement('div');
    iconDiv.className = 'confirm-modal__icon';
    iconDiv.innerHTML = icon;

    const titleEl = document.createElement('h2');
    titleEl.className = 'confirm-modal__title';
    titleEl.textContent = title;

    const messageEl = document.createElement('p');
    messageEl.className = 'confirm-modal__message';
    messageEl.textContent = message;

    const actions = document.createElement('div');
    actions.className = 'confirm-modal__actions';

    // 확인 (체크 아이콘 + 텍스트)
    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = `btn-confirm ${confirmButtonClass}`;
    confirmBtn.dataset.action = 'confirm';
    if (confirmIcon) {
      const iconHost = document.createElement('span');
      iconHost.className = 'btn-confirm__icon';
      iconHost.innerHTML = confirmIcon;
      confirmBtn.appendChild(iconHost);
    }
    const confirmLabel = document.createElement('span');
    confirmLabel.textContent = confirmText;
    confirmBtn.appendChild(confirmLabel);

    // 중립 (예/아니오의 "아니오")
    const neutralBtn = document.createElement('button');
    neutralBtn.type = 'button';
    neutralBtn.className = `btn-confirm ${neutralButtonClass}`;
    neutralBtn.dataset.action = 'neutral';
    neutralBtn.textContent = neutralText;

    // 취소
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = `btn-confirm ${cancelButtonClass}`;
    cancelBtn.dataset.action = 'cancel';
    cancelBtn.textContent = cancelText;

    actions.appendChild(confirmBtn);
    actions.appendChild(neutralBtn);
    actions.appendChild(cancelBtn);

    modal.appendChild(iconDiv);
    modal.appendChild(titleEl);
    modal.appendChild(messageEl);
    modal.appendChild(actions);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    modal.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    overlay.addEventListener('click', () => {
      removeModal();
      resolve('cancel');
    });

    const handleAction = (action) => {
      removeModal();
      resolve(action);
    };

    modal.querySelectorAll('[data-action]').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        handleAction(button.dataset.action);
      });
    });

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        removeModal();
        resolve('cancel');
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);

    function removeModal() {
      overlay.style.animation = 'confirmFadeIn 0.2s ease-out reverse';
      modal.style.animation = 'confirmSlideUp 0.22s ease-out reverse';
      setTimeout(() => {
        if (overlay.parentElement) {
          overlay.parentElement.removeChild(overlay);
        }
        document.removeEventListener('keydown', handleEscape);
      }, 220);
    }
  });
}

export function showToast(message, type = 'info') {
  const existingToast = document.querySelector('.toast');
  if (existingToast) existingToast.remove();

  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;

  const iconPath =
    type === 'success'
      ? 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4L12 14.01l-3-3'
      : type === 'error'
        ? 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01'
        : type === 'warning'
          ? 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01'
          : 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 6v6M12 16h.01';

  // XSS 방지를 위해 createElement + textContent 사용
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('class', 'icon icon--sm');
  svg.setAttribute('viewBox', '0 0 24 24');
  const path = document.createElementNS(svgNS, 'path');
  path.setAttribute('d', iconPath);
  svg.appendChild(path);

  const messageSpan = document.createElement('span');
  messageSpan.textContent = message;

  toast.appendChild(svg);
  toast.appendChild(messageSpan);

  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3000);
}




// 에러 메시지 추출 헬퍼
export function getErrorMessage(error, defaultMessage = '요청에 실패했습니다.') {
  return (
    error.response?.data?.message ||
    error.response?.data?.detail ||
    error.message ||
    defaultMessage
  );
}

// 인증 토큰 저장
export async function saveAuthTokens(data) {
  sessionStorage.setItem('access_token', data.access_token);
  sessionStorage.setItem('refresh_token', data.refresh_token);
  sessionStorage.setItem('token_type', data.token_type);
  sessionStorage.setItem('email', data.email);

  // 새 디자인엔 아직 클래스 선택 사이드바가 없음.
  // 로그인 직후 활성 클래스를 .env의 REACT_APP_BASIC_CLASS_ID로 고정해 둔다.
  // (백엔드 LLM 실습 등은 class_id 기준으로 allowed_model_ids를 검사한다)
  const basicClassId = process.env.REACT_APP_BASIC_CLASS_ID;
  if (basicClassId) {
    sessionStorage.setItem('selected_class_id', String(basicClassId));
  }

  // /user/login 응답엔 partner_id가 없어 /user/my를 추가 조회해 채워둔다.
  // Partner 화면들이 sessionStorage의 partner_id로 path를 구성하기 때문에 비어있으면 422가 난다.
  sessionStorage.removeItem('partner_id');
  try {
    const { default: api } = await import('../api/client');
    const me = await api.get('/user/my');
    if (me?.data?.partner_id != null) {
      sessionStorage.setItem('partner_id', String(me.data.partner_id));
    }
  } catch (e) {
    console.error('partner_id 조회 실패:', e);
  }
}

// 수업 상태 판별
export function getCourseStatus(startAt, endAt) {
  const now = new Date();
  const start = new Date(startAt);
  const end = new Date(endAt);

  now.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  if (now > end) {
    return { type: 'ended', label: '종료' };
  } else if (now < start) {
    const daysUntilStart = Math.ceil((start - now) / (1000 * 60 * 60 * 24));
    return { type: 'upcoming', label: `D-${daysUntilStart}` };
  } else {
    return { type: 'active', label: '진행중' };
  }
}

/**
 * 백엔드 저장 파일명에서 업로드 prefix를 제거한 표시용 이름을 반환한다.
 *
 * Prefix 패턴: `숫자_문자열_원본명` (예: 43_aa013e7c_증시속보_리포트_(2026-05).pdf)
 *   - 첫 토큰이 순수 숫자이고 토큰이 3개 이상이면 앞 2개(숫자_문자열_)를 제거한다.
 *   - 그 외(사용자 로컬 파일명, legacy 형식 등)는 원본을 그대로 반환.
 */
export const getDisplayName = (originName) => {
  if (!originName || typeof originName !== 'string') return originName || '';
  const parts = originName.split('_');
  if (parts.length >= 3 && /^\d+$/.test(parts[0])) {
    return parts.slice(2).join('_');
  }
  return originName;
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

// 날짜 포맷: 2025-12-24
export const formatDate_YY_MM_DD = (date) => {
  if (!date) return '';
  return date.split('T')[0];
};

// ========== 테마 유틸리티 ==========
export function getThemeSetting() {
  return localStorage.getItem('growfit-theme') || 'light';
}

export function resolveTheme(setting) {
  if (setting === 'auto') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return setting;
}

export function setTheme(setting) {
  localStorage.setItem('growfit-theme', setting);
  document.documentElement.classList.add('theme-transitioning');
  document.documentElement.setAttribute('data-theme', resolveTheme(setting));
  setTimeout(() => {
    document.documentElement.classList.remove('theme-transitioning');
  }, 400);
}

export function listenSystemThemeChange() {
  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = () => {
    if (getThemeSetting() === 'auto') {
      document.documentElement.setAttribute('data-theme', resolveTheme('auto'));
    }
  };
  mql.addEventListener('change', handler);
  return () => mql.removeEventListener('change', handler);
}

// 날짜 포맷: 12/24 16:30
export const formatDate_MM_DD_HH_MM = (date) => {
  if (!date) return '';

  const [ymd, time] = date.split('T');
  const mmdd = ymd.slice(5).replace('-', '/');
  const hhmm = time.slice(0, 5);

  return `${mmdd} ${hhmm}`;
};
